<template>
  <div class="box">
    <el-form v-model="queryData">
      <el-input style="width: 200px; margin: 0 10px 10px" v-model.trim="queryData.key" placeholder="配置名称" clearable @clear="clear"></el-input>

      <el-button class="search" type="primary" @click="add_click">添加</el-button>
    </el-form>
    <el-table class="table" :data="tableData" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" style="width: 98.5%; margin-left: 10px" v-loading="tabLoading">
      <el-table-column prop="id" label="用户ID" min-width="60" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="key" label="名称" min-width="60" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="value" label="值" min-width="60" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="name" label="备注" min-width="60" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#A4B8CF" active-value="1" inactive-value="0" @change="changestatus(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="" label="时间" min-width="60" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column label="操作" width="235">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="edeit" @click="editClk(scope.row)">编辑</el-button>
          <el-button type="text" size="small" class="edeit" @click="delClk(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="名称:">
          <el-input v-model="form.key" style="width: 92%" />
        </el-form-item>
        <el-form-item label="值:">
          <el-input v-model="form.value" style="width: 92%" />
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="form.name" style="width: 92%" />
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="form.status" placeholder="请选择" style="width: 92%">
            <el-option label="开启" value="1" />
            <el-option label="关闭" value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="retunDialogVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post } from "@/utils/request";
const moment = require("moment");
export default {
  data () {
    return {
      loading: true,
      title: "",
      activeName: "1",
      tableData: [],
      queryData: {
        pageNum: 1,
        pageSize: 50,
        model: {
          key:""
        },
      },
      form: {
        key: "",
        value: "",
        status: "",
        name: "",
      },
      dialogVisible: false,
      tabLoading: false
    };
  },
  created () {
    this.getSystem();
  },
  methods: {
    editClk (row) {
      this.form = row
      this.title = '编辑配置信息'
      this.dialogVisible = true

    },
    delClk(row){
      this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

      post("/admin/config/delete", {id:row.id}).then((res) => {
        if (res.data.code == 20000) {
          this.$message.success(res.data.message)
          this.getSystem();
        } else {
          this.$message.error(res.data.message)

        }
      })
    })

    },
    changestatus (row) {
      post("/admin/config/update", row).then((res) => {
        if (res.data.code == 20000) {
          this.$message.success(res.data.message)
          this.getSystem();
        } else {
          this.$message.error(res.data.message)

        }
      })
    },
    add_click () {
      this.dialogVisible = true
      this.form = {}
      this.title = '新增配置信息'
    },
    retunDialogVisible () {
      this.dialogVisible = false
      if (this.title == '新增配置信息') {

        post("/admin/config/add", this.form).then((res) => {
          console.log(res.data);
          if (res.data.code == 20000) {
            this.$message.success(res.data.message)
            this.form = {}
            this.getSystem();

          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        post("/admin/config/update", this.form).then((res) => {
          if (res.data.code == 20000) {
            this.$message.success(res.data.message)
            this.form = {}
            this.getSystem();
          } else {
            this.$message.error(res.data.message)

          }

        })
      }


    },
    clear () {
      this.getSystem();

    },
    handleClick (tab, event) {
      this.loading = true;
      this.tableData = [];
      this.queryData.model.group = tab.name;
      this.getSystem();
    },
    // 获取系统配置
    getSystem () {
      post("/admin/config/page", this.queryData).then((res) => {
        this.total = res.data.data.total;
        this.tableData = res.data.data.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  padding: 20px;
  box-sizing: border-box;
}
.header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #f2f3f5;
}
.content {
  width: 50%;
  margin: auto;
}
::v-deep .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}
</style>
